import React from "react";

import type { SearchLocale } from "./searchCopy";
import { getSearchCopy } from "./searchCopy";

interface Props {
  title: string;
  locale: SearchLocale;
  onBack: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  headerAction?: React.ReactNode;
  onScrollEnd?: () => void;
}

const SearchSectionSurface: React.FC<Props> = ({
  title,
  locale,
  onBack,
  children,
  footer,
  headerAction,
  onScrollEnd,
}) => {
  return (
    <div className="overflow-hidden">
      <div className="flex items-center justify-between px-3 py-2 border-b border-eoe-border-main dark:border-eoe-dark-border-main">
        <button
          type="button"
          className="text-sm text-eoe-text-sub dark:text-eoe-dark-text-sub hover:text-eoe-text dark:hover:text-eoe-dark-text"
          onClick={onBack}
        >
          {getSearchCopy(locale, "back")}
        </button>
        <span className="text-sm font-semibold text-eoe-text dark:text-eoe-dark-text">
          {title}
        </span>
        {headerAction ? <div className="flex items-center">{headerAction}</div> : <span className="w-10" />}
      </div>
      <div
        className="max-h-[calc(100dvh-220px)] overflow-y-auto pb-2"
        onScroll={(event) => {
          if (!onScrollEnd) {
            return;
          }

          const target = event.currentTarget;
          const nearBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 80;

          if (nearBottom) {
            onScrollEnd();
          }
        }}
      >
        {children}
      </div>
      {footer ? (
        <div className="border-t border-eoe-border-main dark:border-eoe-dark-border-main px-3 py-2">
          {footer}
        </div>
      ) : null}
    </div>
  );
};

export default SearchSectionSurface;
